export default __webpack_public_path__ + "static/glow-44a7547ab88df9563b86c63949b8ee2a.png";